import React from "react";
import "../../../../static/styles/InfoCards.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Card, CardContent, Typography, Grid, Box } from "@mui/material";
import {
  faOilCan,
  faChartLine,
  faArrowUp,
  faArrowDown,
  faLayerGroup,
} from "@fortawesome/free-solid-svg-icons";
import "../../../../static/styles/InfoCards.css";

const InfoCards = ({ dataSource }) => {
  const convertToBarrels = (volume) => (volume * 6.2898).toFixed(2);

  const filteredData = dataSource
    ? dataSource.filter((item) => item.properties.severity !== 0)
    : [];

  const totalVolume = filteredData.reduce(
    (sum, item) => sum + item.properties.volume,
    0
  );
  const averageVolume = filteredData.length
    ? totalVolume / filteredData.length
    : 0;
  const maxVolume = filteredData.length
    ? Math.max(...filteredData.map((item) => item.properties.volume))
    : 0;
  const minVolume = filteredData.length
    ? Math.min(...filteredData.map((item) => item.properties.volume))
    : 0;

  const totalVolumeBarrels = convertToBarrels(totalVolume);
  const averageVolumeBarrels = convertToBarrels(averageVolume);
  const maxVolumeBarrels = convertToBarrels(maxVolume);
  const minVolumeBarrels = convertToBarrels(minVolume);

  const volumeBySeverity = filteredData.reduce((acc, item) => {
    const severity = item.properties.severity;
    const severityName = {
      1: "Minor",
      2: "Moderate",
      3: "Major",
      4: "Remediated"
    }[severity];

    if (!acc[severityName]) {
      acc[severityName] = 0;
    }
    acc[severityName] += item.properties.volume;
    return acc;
  }, {});

  const volumeBySeverityBarrels = {};
  Object.keys(volumeBySeverity).forEach((key) => {
    volumeBySeverityBarrels[key] = convertToBarrels(
      volumeBySeverity[key]
    );
  });

  const cardsData = [
    {
      title: "Total Volume",
      description:
        totalVolumeBarrels !== "0.00"
          ? `${totalVolumeBarrels} Barrels`
          : "No data",
      icon: faOilCan,
      color: "#f8b400",
    },
    {
      title: "Average Volume",
      description:
        averageVolumeBarrels !== "0.00"
          ? `${averageVolumeBarrels} Barrels`
          : "No data",
      icon: faChartLine,
      color: "#4caf50",
    },
    {
      title: "Max Volume",
      description:
        maxVolumeBarrels !== "0.00" ? `${maxVolumeBarrels} Barrels` : "No data",
      icon: faArrowUp,
      color: "#f44336",
    },
    {
      title: "Min Volume",
      description:
        minVolumeBarrels !== "0.00" ? `${minVolumeBarrels} Barrels` : "No data",
      icon: faArrowDown,
      color: "#2196f3",
    },
    ...["Minor", "Moderate", "Major", "Remediated"].map((severityName) => ({
      title: `Volume of ${severityName} Observations`,
      description: volumeBySeverityBarrels[severityName]
        ? `${volumeBySeverityBarrels[severityName]} Barrels`
        : "No data",
      icon: faLayerGroup,
      color: "#9c27b0",
    })),
    {
      title: "Observation Count",
      description: filteredData.length
        ? `${filteredData.length} Observations`
        : "No data",
      icon: faLayerGroup,
      color: "#9e9e9e",
    },
  ];

  return (
    <Box sx={{ padding: "10px" }} maxHeight={"30vh"} minHeight={"16vh"}>
      <Grid container spacing={2} >
        {cardsData.map((item, index) => (
          <Grid item xs={6} sm={3} md={3} key={index}>
            <Card
              className="info-card"
              sx={{
                height: "14vh",
                display: "flex",
                flexDirection: "column",
                borderRadius: "12px",
                overflow: "hidden",
                background: `linear-gradient(145deg, #ffffff, #f0f0f0)`,
                boxShadow: "5px 5px 10px #d9d9d9, -5px -5px 10px #ffffff",
              }}
            >
              <CardContent
                sx={{
                  padding: "10px",
                  height: "100%",
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "center",
                  alignItems: "center",
                  textAlign: "center",
                  background: `linear-gradient(145deg, ${item.color}11, ${item.color}22)`,
                }}
              >
                <Box
                  className="info-card-icon"
                  sx={{
                    mb: 3,
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  <FontAwesomeIcon
                    icon={item.icon}
                    style={{
                      color: item.color,
                      fontSize: "1.8rem",
                    }}
                  />
                </Box>
                <Typography
                  variant="body2"
                  component="p"
                  sx={{
                    mb: 1,
                    fontWeight: "bold",
                    color: "text.secondary",
                    fontSize: "0.7rem",
                    width: "100%",
                  }}
                >
                  {item.title.toUpperCase()}
                </Typography>
                <Typography
                  variant="h6"
                  component="h3"
                  sx={{
                    fontWeight: "bold",
                    color:
                      item.description === "No data"
                        ? "text.secondary"
                        : item.color,
                    fontSize: "1rem",
                    lineHeight: 1.2,
                    width: "100%",
                  }}
                >
                  {item.description}
                </Typography>
              </CardContent>
            </Card>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};

export default InfoCards;
